import React, { useRef, useEffect, useState } from 'react';
import { Container, CardBody, Card } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { PreviewHTML } from 'vivace-fluent-motion';
import * as commonActions from '@common/common.action';
import SolicitacaoApi from '../../solicitacao.api';
import { returnParamiters } from '../../solicitacao.utils';
import Impressao from './Impressao';
import IntlMessage from '../../../../../src/helpers/intlMessage';

function Relatorio ({
  showModalImprimir,
  setShowModalImprimir,
  total,
  filtro
}) {
  const componentRef = useRef();
  const dispatch = useDispatch();

  const lista = useSelector(state => state.solicitacao.listaSolicitacoes);
  const dadosGeraisHospital = useSelector(
    state => state.commonReducer.dadosGeraisHospital
  );

  const [previewHTML, setPreviewHTML] = useState(false);
  const [itens, setItens] = useState([]);
  const [itensFormatados, setItensFormatados] = useState([]);

  useEffect(() => {
    if (showModalImprimir) {
      if (lista && total > lista.length) {
        filtrar({ ...filtro, pagina: 1, lista: [] });
      } else {
        setItens(lista);
        setPreviewHTML(true);
      }
    }
  }, [showModalImprimir]);

  useEffect(() => {
    const listaFormatada = itens.map(item => ({
      ...item
    }));
    setItensFormatados(listaFormatada);
  }, [itens]);

  const filtrar = async filtro => {
    try {
      const {
        usuarioExecutante,
        usuarioSolicitante,
        periodoInicial,
        periodoFinal,
        tipo,
        value,
        pagina,
        lista
      } = filtro;

      let params = returnParamiters({
        periodoInicial,
        periodoFinal,
        tipo,
        value
      });

      if (usuarioSolicitante) params.usuarioSolicitante = usuarioSolicitante;

      if (usuarioExecutante) params.usuarioExecutante = usuarioExecutante;

      dispatch(commonActions.showFadeCarregando(true));
      const response = await SolicitacaoApi.get(params, pagina);
      const novaLista = [...lista, ...response.data];

      if (novaLista.length < total) {
        return filtrar({ ...filtro, pagina: pagina + 1, lista: novaLista });
      }

      setItens(novaLista);
      dispatch(commonActions.showFadeCarregando(false));
      setPreviewHTML(true);
    } catch (error) {
      dispatch(commonActions.showFadeCarregando(false));
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dadosGeraisHospital.razaosoc
  });

  const ComponentHTML = ({ id }) => {
    return (
      <div className='mv-visualizador-html'>
        <Card id={id}>
          <CardBody>
            <Container fluid>
              <div ref={componentRef}>
                <Impressao lista={itensFormatados} />
              </div>
            </Container>
          </CardBody>
        </Card>
      </div>
    );
  };

  return (
    <div>
      <PreviewHTML
        messageTitle = {<IntlMessage id = "dashboards.reports.printPreview"/>} 
        printLabel = {<IntlMessage id = "dashboards.reports.printOut"/>}
        visible={previewHTML}
        id='uniqueID'
        component={<ComponentHTML id='uniqueID' />}
        onOpened={e => {
          setPreviewHTML(e);
          setShowModalImprimir(e);
        }}
        onPrint={handlePrint}
      />
    </div>
  );
}

export default Relatorio;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Solicitacoes/Relatorio/index.js